var APP = {
    page: '',
    lang: '',
    map: null,
    currentLocation: null,
    adega: null,
    daysOff: [],
    init: function (page, lang) {
        APP.page = page;
        APP.lang = lang;
        APP.initSocialVideo();
        APP.setupDropdowns();
        UTILS.initCookieInfo();

        /* check if we need slideshow */
        $('.slideshow').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true
        });

        if ($('#daysoff-data').length) {
            APP.daysOff = JSON.parse($('#daysoff-data').val());
        }

        if ($('#adega-data').length) {
            APP.adega = JSON.parse($('#adega-data').val());
        }

        var get_vars = UTILS.getUrlVars();
        if (get_vars['rpt']) {
            console.log('show recover pass popup');
            APP.openPopup('#modal-update-password');
        }
        var minDate = new Date();
        if (minDate.getHours() > 17) minDate.setDate(minDate.getDate() + 3);
        else minDate.setDate(minDate.getDate() + 2);

        // $('.input-date').datepicker({
        //   language: APP.lang,
        //   minDate: minDate,
        //   firstDay: 1,
        //   dateFormat: 'yyyy-mm-dd',
        //   autoClose: true,
        //   onSelect: function(formattedDate, date, inst) {
        //     inst.$el.change();
        //   }
        // });

        var i18n;
        if (APP.lang == 'en') {
            i18n = {
                previousMonth: 'Previous Month',
                nextMonth: 'Next Month',
                months: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                weekdays: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],
                weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
            };
        } else {
            i18n = {
                previousMonth: 'Mês Anterior',
                nextMonth: 'Próximo Mês',
                months: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro'
                ],
                weekdays: [
                    'Domingo',
                    'Segunda',
                    'Terça',
                    'Quarta',
                    'Quinta',
                    'Sexta',
                    'Sábado'
                ],
                weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
            };
        }

        $('.input-date').each((index, item) => {
            var picker = new Pikaday({
                field: item,
                minDate: minDate,
                format: 'yyyy-MM-DD',
                disableDayFn: function (date) {
                    let week = [
                        'sunday',
                        'monday',
                        'tuesday',
                        'wednesday',
                        'thursday',
                        'friday',
                        'saturday'
                    ];

                    if (APP.adega && APP.adega[week[date.getDay()]] == 0) return true;

                    let momentDate = moment(date.getTime()).format('YYYY-MM-DD');
                    for (let i = 0; i < APP.daysOff.length; i++) {
                        if (
                            momentDate >= APP.daysOff[i].start_date &&
                            momentDate <= APP.daysOff[i].end_date
                        )
                            return true;
                    }
                },
                i18n: i18n
            });
        });
        // var picker = new Pikaday({ field: $('.input-date')[0] });
    },
    handleRestaurantClick: function (value) {
        if (value == 1) {
            $('.restaurant-schedule-group').removeClass('is-hidden');
            $('.restaurant-dinner-schedule-group').addClass('is-hidden');
        } else if (value == 2) {
            $('.restaurant-schedule-group').addClass('is-hidden');
            $('.restaurant-dinner-schedule-group').removeClass('is-hidden');
        } else {
            $('.restaurant-schedule-group').removeClass('is-hidden');
            $('.restaurant-dinner-schedule-group').removeClass('is-hidden');
        }
    },
    showPasswordLogin: function () {
        let passField = $('input[name=password]');
        if (!$('.icon-eye').hasClass('is-visible')) {
            passField.prop('type', 'text');
            $('.icon-eye').addClass('is-visible');
        } else {
            passField.prop('type', 'password');
            $('.icon-eye').removeClass('is-visible');
        }
    },
    sendContact: function (event) {
        FORMS.sendForm(
            event,
            '#form-contacts2',
            'send_contact.php',
            function (form_name) {
                return true;
            },
            function (response) {
                console.log('ok callback', response);
            },
            function (error) {
                console.log('nok callback', error);
            },
            true
        );
    },
    sendContactWithAttach: function (event) {
        FORMS.sendForm(
            event,
            '#form-contacts',
            'send_contact.php',
            function (form_name) {
                console.log('extra_validation on ' + form_name);
                return true;
            },
            function (response) {
                console.log('ok callback', response);
            },
            function (error) {
                console.log('nok callback', error);
            },
            true
        );
    },
    initSocialVideo: function () {
        $('.social-video').each(function (index, element) {
            APP.loadSocialVideo(this);
        });
    },
    loadSocialVideo: function (obj) {
        if ($(obj).attr('src') != '') return;

        var video = $(obj).attr('data-id');

        var video_id;
        if (video.indexOf('youtu.be') != -1 || video.indexOf('youtube.com') != -1) {
            video_id =
                '//www.youtube.com/embed/' +
                UTILS.parseYoutubeURL(video) +
                '?rel=0&showinfo=0&controls=1';
        } else if (video.indexOf('vimeo.com') != -1) {
            video_id = '//player.vimeo.com/video/' + UTILS.parseVimeoURL(video);
        }

        $(obj).attr('src', video_id);
    },
    openPopup: function (id) {
        console.log(id);
        $('.modal').removeClass('is-active');
        $(id).addClass('is-active');

        //clean up message
        $(id)
            .find('.form-message')
            .html('');

        //ungly code because we hide stuff on success scenarios, we need to put it back
        $(id)
            .find('.field')
            .removeClass('is-hidden');
        $(id)
            .find('.columns')
            .removeClass('is-hidden');

        //reset the form if there is one
        $(id)
            .find('form')
            .trigger('reset');

        $('html').addClass('is-clipped');

        if (id == '#modal-video') {
            APP.loadSocialVideo($('#modal-video .social-video'));
        }
    },
    closePopup: function () {
        $('.modal').removeClass('is-active');
        $('html').removeClass('is-clipped');

        $('#modal-video iframe').attr('src', '');
    },
    setupDropdowns: function () {
        var $dropdowns = $('.dropdown:not(.is-hoverable)');

        if ($dropdowns.length > 0) {
            $dropdowns.each(function () {
                var $this = $(this);
                $this.click(function (event) {
                    event.stopPropagation();
                    $dropdowns.each(function () {
                        $(this).removeClass('is-active');
                    });
                    $this.toggleClass('is-active');
                });
            });

            $(document).click(function () {
                $dropdowns.each(function () {
                    $(this).removeClass('is-active');
                });
            });
        }
    },
    hasCenteredMap: false,
    setupMap: function (el, view, trackView, geolocate = false) {
        this.map = new ol.Map({
            controls: [new ol.control.Zoom()],
            // desliga o shift + drag zoom, eu pessoalmente nao gosto
            interactions: ol.interaction.defaults({
                shiftDragZoom: false,
                altShiftDragRotate: false,
                // pinchRotate: false,
                mouseWheelZoom: true
            }),
            target: el,
            layers: [
                new ol.layer.Tile({
                    source: new ol.source.OSM()
                })
                // vectorLayer
            ],
            view: view
        });

        if (geolocate) {
            // set up the geolocation api to track our position
            var geolocation = new ol.Geolocation({
                // trackingOptions: {
                //   enableHighAccuracy: true
                // },
                projection: view.getProjection(),
                tracking: true
            });

            var accuracyFeature = new ol.Feature();
            accuracyFeature.setProperties({ selectable: false });
            geolocation.on('change:accuracyGeometry', function () {
                accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
            });

            var positionFeature = new ol.Feature();
            positionFeature.setProperties({ selectable: false });
            positionFeature.setStyle(
                new ol.style.Style({
                    image: new ol.style.Circle({
                        radius: 6,
                        fill: new ol.style.Fill({
                            color: '#3399CC'
                        }),
                        stroke: new ol.style.Stroke({
                            color: '#fff',
                            width: 2
                        })
                    })
                })
            );
            var vectorLayer = new ol.layer.Vector({
                source: new ol.source.Vector({
                    features: [accuracyFeature, positionFeature]
                })
            });

            this.map.addLayer(vectorLayer);

            geolocation.on('change:position', function () {
                var coordinate = geolocation.getPosition();
                APP.currentLocation = ol.proj.transform(
                    coordinate,
                    'EPSG:3857',
                    'EPSG:4326'
                );
                console.log(APP.currentLocation);
                if (trackView && !APP.hasCenteredMap) {
                    console.log(':::', coordinate);
                    view.setCenter(coordinate);
                    view.setZoom(7);
                    APP.hasCenteredMap = true;
                }
                positionFeature.setGeometry(
                    coordinate ? new ol.geom.Point(coordinate) : null
                );
            });
        }
    },
    rate: function (rating, input, xp_id) {
        $(input).val(rating);
        var stars = $('.rating-container .star');
        stars.removeClass('is-active');
        $(
            stars
                .get()
                .reverse()
                .slice(0, rating)
        ).addClass('is-active');
    },
    sendReview: function () {
        if ($('#rating').val() == '') return;
        UTILS.blockUI(true);
        axios
            .post('requests/send_review.php', {
                experience_id: $('#experience-id').val(),
                rating: $('#rating').val(),
                comment: $('#rating-comment').val()
            })
            .then(function (response) {
                console.log('ok');
                //$("#form-message-rating").html(response.data.message);
                FORMS.showUserMessage(
                    response.data.message,
                    FORMS.MESSAGE_OK,
                    '#form-message-rating',
                    false
                );
                $('.button-send-rating').addClass('is-hidden');
            })
            .catch(function (error) {
                console.log('error');
                FORMS.showUserMessage(
                    error.response.data.message,
                    FORMS.MESSAGE_ERROR,
                    '#form-message-rating',
                    false
                );
            })
            .finally(function () {
                UTILS.blockUI(false);
            });
    },
    signUpAdega: function (event) {
        FORMS.sendForm(
            event,
            '#form-adega',
            'signup_adega.php',
            function (form_name) {
                if ($('#terms:checked').length == 0) {
                    FORMS.showUserMessage(
                        TOKEN.TERMS_ERROR,
                        FORMS.MESSAGE_ERROR,
                        '#form-adega .form-message',
                        false
                    );
                    return false;
                } else return true;
            },
            function (response) {
                console.log('ok callback', response);
                $('#form-adega .form-wrap, #button-adega-submit').addClass('is-hidden');
            },
            function (error) {
                console.log('nok callback', error);
            },
            true
        );
    },
    updateProfile: function (event) {
        FORMS.sendForm(
            event,
            '#form-profile',
            'update_profile.php',
            function (form_name) {
                console.log(form_name);
                return true;
            },
            function (response) {
                console.log('ok callback', response);
                $('#form-adega .form-wrap, #button-adega-submit').addClass('is-hidden');
            },
            function (error) {
                console.log('nok callback', error);
            },
            true
        );
    },
    updateFavorite: function (adega_id, state) {
        UTILS.blockUI(true);
        axios
            .post('requests/favorites.php', {
                adega_id: adega_id,
                state: state
            })
            .then(function (response) {
                console.log('ok callback', response.data);
                //remove from the dom
                $(".product-item[data-id='" + adega_id + "']")
                    .parent('.product-item-container')
                    .remove();
            })
            .catch(function (error) {
                console.error(error.response);
                if (error.response.data.code == -2) {
                    APP.openPopup('#modal-login');
                }
            })
            .finally(function () {
                UTILS.blockUI(false);
            });
    },
    updateNumberInput: function (name, value) {
        var $el = $('input[name="' + name + '"]');
        var current = parseInt($el.val()) || 0;
        var n = Math.min(
            $el.attr('max'),
            Math.max($el.attr('min'), current + value)
        );
        $el.val(n);
        $el.change();
    },
    openClassify: function (
        experience_title,
        adega_title,
        adega_region,
        experience_id
    ) {
        $('.button-send-rating').removeClass('is-hidden');

        $('#modal-classify .experience-name').html(experience_title);
        $('#modal-classify .adega-name').html(adega_title);
        $('#modal-classify .region-name').html(adega_region);
        $('#experience-id').val(experience_id);
        APP.openPopup('#modal-classify');
    },
    showNewMessagePopup: function (to_name, to_id) {
        $('#modal-message-to').html(to_name);
        $('#modal-message-to-id').val(to_id);

        APP.openPopup('#modal-message');
    },
    showMessageDetail: function (
        subject,
        date,
        message,
        message_id,
        row_dom,
        to_id,
        to_name,
        parent_id,
        reply_id,
        reply_email_name
    ) {
        console.log("🚀 ~ subject", subject,
            date,
            message,
            message_id,
            row_dom,
            to_id,
            to_name,
            parent_id,
            reply_id);
        $('#modal-message .subject').html(subject);
        $('#modal-message .message-date').html(date);
        $('#modal-message .content').html(message);
        $('#modal-message-id').val(message_id);

        var reply_to = to_id;
        var reply_name = to_name;

        if (parent_id == to_id) {
            reply_to = reply_id;
            reply_name = reply_email_name;
        }

        $('#modal-message-to-id').val(reply_to);
        $('#modal-message-to').html(reply_name);

        APP.openPopup('#modal-message');

        //check open on the DB
        UTILS.blockUI(true);
        axios
            .post('requests/read_message.php', {
                id: message_id
            })
            .then(function (response) {
                //window.location.reload();
            })
            .catch(function (error) {
            })
            .finally(function () {
                UTILS.blockUI(false);
            });

        //update UI table
        $(row_dom).removeClass('unread');

        if ($(row_dom).attr('data-unread') == 1) {
            //update number of unread
            var n_unread = Number(
                $('.menu-profile_messages')
                    .find('.badge')
                    .html()
            );
            $('.menu-profile_messages')
                .find('.badge')
                .html(n_unread - 1);

            $(row_dom).attr('data-unread', '0');
        }
    },
    updateMenuBadgeNumber: function (item, amount) {
        if (parseInt(amount) > 0) {
            $(item)
                .find('.badge')
                .text(amount);
        } else {
            $(item)
                .find('.badge')
                .text('');
        }
    },
    sendMessage: function (event) {
        event.preventDefault();
        UTILS.blockUI(true);

        axios
            .post('requests/send_message.php', {
                msg_id: $('#modal-message-id').val(),
                message: $('#modal-message-textarea').val(),
                subject: $('#modal-message-subject').val(),
                to_id: $('#modal-message-to-id').val(),
                to_name: $('#modal-message-to').html()
            })
            .then(function (response) {
                console.log('ok callback', response.data);
                APP.closePopup();
                window.location.reload();
            })
            .catch(function (error) {
                console.error(error.response);
            })
            .finally(function () {
                UTILS.blockUI(false);
            });
    },
    blockUI() {
        document.getElementsByTagName('html')[0].style.cursor = 'wait';
        document.getElementsByTagName('html')[0].style['pointer-events'] = 'none';
    },
    releaseUI() {
        document.getElementsByTagName('html')[0].style.cursor = 'auto';
        document.getElementsByTagName('html')[0].style['pointer-events'] = 'auto';
    },
    toggleMobileMenu() {
        $('.hamburger, .navbar-menu').toggleClass('is-active');
    },
    goToLocation() {
        const city = $('#city option:selected');

        if (city.attr('data-lon')) {
            const coord = ol.proj.transform(
                [city.attr('data-lon'), city.attr('data-lat')],
                'EPSG:4326',
                'EPSG:3857'
            );

            this.map.getView().setCenter(coord);
        }
        this.map.getView().setZoom($('#radius option:selected').attr('data-zoom'));

        LISTING.searchItems();
    }
};
